module.exports = __webpack_public_path__ + "img/144.b1a85466.jpg";